<style lang="stylus">
    .ai-topbartip
        // height 16px
        display: flex;
        .ivu-tooltip-rel {
            display flex;
        }
        .ivu-tooltip-popper
            .ivu-tooltip-inner
                border-radius 6px
                background var(--bg-color-ai-set-tool-tip)
            .ivu-tooltip-arrow
                border-bottom-color var(--bg-color-ai-set-tool-tip)
        svg
            width 16px;
            height 17px;
            color: var(--svg-color-primary);
        .ai-topbartip-content
            display flex
            flex-direction column
            row-gap 8px
            p
                color #fff
                font-size 12px
                line-height 16px
                white-space normal
                span
                    color var(--themeColor)
                    cursor pointer
            .ai-topbartip-list
                display flex
                flex-direction column
                row-gap 8px
                list-style decimal
                padding-left 10px
                white-space normal
</style>

<template>
    <Tooltip class="ai-topbartip" :theme="'dark'">
        <iconSymbol class="question-icon" name="ai-question" />
        <template #content>
            <div class="ai-topbartip-content">
                <i18n path="title" tag="p">
                    <span @click="toPage">{{ $t("entry") }}</span>
                </i18n>
                <ul class="ai-topbartip-list">
                    <li>{{ $t("tips1") }}</li>
                    <li>{{ $t("tips2") }}</li>
                    <li>{{ $t("tips3") }}</li>
                </ul>
            </div>
        </template>
    </Tooltip>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import { Tooltip } from "iview";

    @Component
    export default class AiTips extends Vue {
        toPage() {
            this.$bus.$emit("showAgreement", "read");
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "title": "亿图AI功能为用户提供便捷的内容生成服务，希望您合规使用本服务，详细说明请点击阅读{0}。",
        "entry": "《AI功能使用协议》",
        "tips1": "每1个AI点数大约可以生成10个字符，以实际消耗的点数为准；",
        "tips2": "点击使用相关的场景功能后，每次会额外消耗一定的AI点数；",
        "tips3": "开启上下文对话后，每次发送的信息会携带之前的记录，消耗的AI点数也会增多。",
        "": ""
    },
    "en": {
        "title": "The Edraw AI features provide users with convenient content generation services. Please use this service lawfully. For a detailed explain, please click to read the {0}。",
        "entry": "\"AI Features User Agreement.\"",
        "tips1": "Each 1 AI point can create around 10 characters; the actual number of points spent shall prevail;",
        "tips2": "Once you click to use the relevant setting features, you will additionally spend a certain number of AI points;",
        "tips3": "If contextual dialog is enabled, the information sent each time will carry all previous records, and the AI points you spend will also increase.",
        "": ""
    },
    "fr": {
        "title": "La fonction IA d'Edraw fournit aux utilisateurs des services pratiques  de génération de contenu. Veuillez utiliser ce service légalement. Pour une explication détaillée, cliquez pour lire le « Contrat d{0}.",
        "entry": "’utilisation des fonctionnalités IA »",
        "tips1": "Veuillez d'abord sélectionner la forme de l'organigramme sur la zone de dessin avant de continuer",
        "tips2": "La fonction IA d'Edraw fournit aux utilisateurs des services pratiques  de génération de contenu. Veuillez utiliser ce service légalement. Pour une explication détaillée, cliquez pour lire le « Contrat d’utilisation des fonctionnalités IA ».",
        "tips3": "Chaque point IA peut créer environ 10 caractères ; le nombre réel de points utilisés prévaudra ;",
        "": ""
    },
    "de": {
        "title": "Die Edraw AI-Funktionen bieten Benutzern praktische Dienste zur Inhaltsgenerierung. Verwenden Sie diesen Service bitte rechtmäßig. Eine ausführliche Erläuterung finden Sie in der {0}.",
        "entry": "„Benutzervereinbarung für AI-Funktionen“",
        "tips1": "Jeder AI-Punkt kann etwa 10 Zeichen erstellen; die tatsächliche Anzahl der ausgegebenen Punkte hat Vorrang.",
        "tips2": "Wenn Sie auf die entsprechenden Einstellungsfunktionen klicken, verwenden Sie zusätzlich eine bestimmte Anzahl von AI-Punkten.",
        "tips3": "Wenn ein kontextbezogenes Dialogfeld aktiviert ist, werden die Informationen, die jedes Mal gesendet werden, alle vorherigen Datensätze enthalten, und die AI-Punkte, die Sie verwenden, steigen ebenfalls.",
        "": ""
    },
    "jp": {
        "title": "Edraw AI機能により、ユーザーは手ごろなコンテンツ生成サービスを利用できます。このサービスは合法的にご利用ください。詳しい説明については、{0}をクリックしてお読みください。",
        "entry": "「AI機能ユーザー契約」",
        "tips1": "1 AIポイントにつき、10文字程度作成できます。実際に使用したポイント数が優先されます。",
        "tips2": "クリックして関連する設定機能を使用すると、一定数のAIポイントがさらに使用されます。",
        "tips3": "コンテキストダイアログを有効にすると、毎回送信される情報には以前のすべてのレコードが引き継がれ、使用するAIポイントも増加します。",
        "": ""
    },
    "es": {
        "title": "La función de AI de Edraw proporciona a los usuarios servicios prácticos para generar contenido. Utilice este servicio de forma legítima. Si quiere obtener una explicación detallada, haga clic para leer el {0}.",
        "entry": "\"Acuerdo de usuario de las funciones de IA\"",
        "tips1": "Cada punto de IA puede crear alrededor de 10 caracteres; prevalecerá el número real de puntos gastados;",
        "tips2": "En cuanto haga clic para utilizar las funciones de configuración relevantes, gastará, además, un determinado número de puntos de IA;",
        "tips3": "Si el cuadro de diálogo contextual está activado, la información enviada cada vez incluirá todos los registros anteriores y también aumentarán los puntos de IA que gaste.",
        "": ""
    },
    "pt": {
        "title": "Os recursos de IA do Edraw oferecem aos usuários serviços convenientes de geração de conteúdo. Use este serviço legalmente. Para obter uma explicação detalhada, clique para ler o {0}.",
        "entry": "\"Contrato de Usuário de Recursos de IA\"",
        "tips1": "Cada ponto de IA pode criar cerca de 10 caracteres. O número real de pontos utilizados prevalecerá;",
        "tips2": "Ao clicar para usar os recursos de configuração relevantes, você também utilizará um determinado número de pontos de IA;",
        "tips3": "Se o diálogo contextual estiver ativado, as informações enviadas a cada vez levarão todos os registros anteriores, e os pontos de IA utilizados também aumentarão.",
        "": ""
    },
    "it": {
        "title": "Le funzioni Edraw AI offrono agli utenti servizi pratici di generazione dei contenuti. Utilizza questo servizio in conformità alle normative vigenti. Per una spiegazione dettagliata, fai clic per leggere il {0}",
        "entry": "\"Contratto per l'utente relativo alle funzioni AI\"",
        "tips1": "Ogni punto AI può creare circa 10 caratteri; prevarrà il numero effettivo di punti spesi.",
        "tips2": "Dopo aver fatto clic per utilizzare le funzioni di impostazione pertinenti, spenderai anche un certo numero di punti AI.",
        "tips3": "Se la finestra di dialogo contestuale è attivata, le informazioni inviate ogni volta trasmettono tutti i record precedenti, mentre i punti AI spesi aumenteranno.",
        "": ""
    },
    "tw": {
        "title": "Edraw AI 功能為使用者提供便利的內容產生服務。使用此服務時請勿違反相關法規。如需詳細說明，請按一下以閱讀{0}。",
        "entry": "「AI 功能使用者協議」",
        "tips1": "每 1 個 AI 點數可建立約 10 個字元；以實際使用點數為準；",
        "tips2": "按一下以使用相關的設定功能後，您還會再花費一定數量的 AI 點數；",
        "tips3": "如果啟用情境對話，每次傳送的資訊都會包含所有先前的記錄，而您花費的 AI 點數也會增加。",
        "": ""
    },
    "kr": {}
}
</i18n>
